import { render, staticRenderFns } from "./ItemCreateView.vue?vue&type=template&id=211f4832&scoped=true&"
import script from "./ItemCreateView.vue?vue&type=script&lang=js&"
export * from "./ItemCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f4832",
  null
  
)

export default component.exports